import { CertificateTypeFilterEnum } from '@/generated/graphql/types';

import type { TFilterDiplomasCollaboratorOption } from './type';

export const DIPLOMA_FILTER = {
  ALL: 0,
  CERTIFICATIONS: 1,
  CONSTANCIES: 2,
} as const;

export const DIPLOMA_FILTER_COLLABORATOR: Record<
  string,
  TFilterDiplomasCollaboratorOption
> = {
  ALL: 'ALL',
  CERTIFICATIONS_COURSE: CertificateTypeFilterEnum.CertificateTypeCourse,
  CERTIFICATIONS_TRACKS: CertificateTypeFilterEnum.CertificateTypeTrack,
  CERTIFICATIONS_LIVE_SESSION:
    CertificateTypeFilterEnum.CertificateTypeLiveSession,
  CERTIFICATIONS_ACCREDITATION:
    CertificateTypeFilterEnum.CertificateTypeCourseAccreditation,
  PARTICIPANTS_CERTIFICATIONS:
    CertificateTypeFilterEnum.CertificateTypeParticipationCertificate,
} as const;
